/**
 * Módulos contratados — FONTE ÚNICA dos slugs no frontend (ADR-0102).
 *
 * Módulo é um adicional do catálogo da Pharu que liga uma parte do ERP. Hoje
 * são as telas que só existem por causa das planilhas e do processo da
 * cliente-piloto. Quem decide se a unidade tem o módulo é o contrato: o
 * backend devolve `modulos_contratados` em `/api/me/permissoes` (a mesma
 * resposta que faz as rotas do módulo darem 404) e o `temModulo` do
 * AuthContext lê dali. Sem o módulo, o menu esconde as telas e a rota leva
 * ao destino padrão, como um caminho que não existe.
 *
 * Slugs iguais aos de `plataforma/modulos.py` no backend.
 */

export const MODULO_PLANILHA_LEGADO = "planilha-legado";
export const MODULO_PROJETOS_EXECUTIVOS = "projetos-executivos";
export const MODULO_CENTRAL_PROJETOS = "central-projetos";

/**
 * `temModulo` a partir do payload de `/api/me/permissoes`. Sem bypass de
 * Master (ter contratado é contrato, não permissão).
 *
 * Payload sem a chave (backend anterior ao ADR-0102, ou sessão guardada antes
 * dele até o boot recarregar as permissões): não esconde nada — o backend
 * continua decidindo com 404. Sem permissões carregadas, nada.
 */
export function verificadorDeModulos(permissoes) {
  const lista = permissoes?.modulos_contratados;
  if (!Array.isArray(lista)) {
    const carregadas = Boolean(permissoes);
    return () => carregadas;
  }
  const contratados = new Set(lista);
  return (slug) => contratados.has(slug);
}
